(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/init.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/init.js');
'use strict';

const _svs$selfExclusion$co = svs.selfExclusion.components,
  SelfExclusionMain = _svs$selfExclusion$co.SelfExclusionMain,
  SelfExclusionNotPLayer = _svs$selfExclusion$co.SelfExclusionNotPLayer;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
svs.selfExclusion.init = () => {
  ReactDOM.render(React.createElement(ErrorBoundary, null, isLoggedIn ? React.createElement(SelfExclusionMain, null) : React.createElement(SelfExclusionNotPLayer, null)), document.getElementsByClassName('js-react-container')[0]);
};
svs.selfExclusion.init();

 })(window);